import React, { useEffect } from 'react'
import { BaseNodeProps } from '../../base/types'
import { Handle, Position } from 'reactflow'
import NodeTemplate from '../../base/NodeTemplate'
import { ActionEntityOperationFindConfiguration } from './ActionEntityOperationFindForm'

const ActionEntityOperationFind = React.memo(
  ({
    data,
    isConnectable,
  }: BaseNodeProps<ActionEntityOperationFindConfiguration>) => {
    const title = 'Trouver une entité'
    useEffect(() => {}, [])
    return (
      <>
        <Handle
          type="target"
          position={Position.Left}
          isConnectable={isConnectable}
        />
        <NodeTemplate icon={'database'} title={title} name={data.name} />
        <Handle
          type="source"
          position={Position.Right}
          id="a"
          isConnectable={isConnectable}
        />
      </>
    )
  }
)

export default ActionEntityOperationFind
